// @ts-nocheck

import cotekillerImage from './cotekiller.png';

export const cotekiller = {
  image: cotekillerImage,
  top: '-2%',
  left: '15%',
  width: '45%',
};
